import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { COLORS, FONT } from "../../shared/styles";
import { formatGroupLabel } from "./constants";
import { ReactComponent as DropdownIcon } from "../../../../../assets/images/dropdown-arrow.svg";
import {
  peopleScrollSelectMenuProps,
  peopleSelectControlSx,
  peopleSelectSx,
} from "../../../People/peopleSelectStyles";

const sectionTitleSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "34px",
  m: 0,
};

const menuItemSx = {
  fontFamily: "Inter",
  fontSize: 14,
};

function ChatWidgetGroupSelect({ groups, value, onChange, loading }) {
  const selectMenuProps = peopleScrollSelectMenuProps();

  const renderValue = (selected) => {
    if (loading && !selected) {
      return (
        <Typography sx={{ color: "#93A1B0", fontFamily: "Inter", fontSize: 14 }}>
          Loading groups...
        </Typography>
      );
    }
    if (!selected) {
      return (
        <Typography sx={{ color: "#93A1B0", fontFamily: "Inter", fontSize: 14 }}>
          Select Group
        </Typography>
      );
    }
    const group = groups.find((g) => g.id === selected);
    if (group) return formatGroupLabel(group);
    if (loading) {
      return (
        <Typography sx={{ color: "#93A1B0", fontFamily: "Inter", fontSize: 14 }}>
          Loading groups...
        </Typography>
      );
    }
    return selected;
  };

  return (
    <Box sx={{ mt: "32px" }}>
      <Typography component="h3" sx={sectionTitleSx}>
        Select Group
      </Typography>
      <TextField
        select
        fullWidth
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading || !groups.length}
        sx={{
          ...peopleSelectControlSx({ maxWidth: "100%" }),
          mt: "16px",
        }}
        SelectProps={{
          displayEmpty: true,
          renderValue,
          IconComponent: DropdownIcon,
          MenuProps: selectMenuProps,
          sx: peopleSelectSx,
        }}
      >
        {!groups.length ? (
          <MenuItem value="" disabled sx={menuItemSx}>
            {loading ? "Loading groups..." : "No groups available"}
          </MenuItem>
        ) : (
          groups.map((group) => (
            <MenuItem key={group.id} value={group.id} sx={menuItemSx}>
              {formatGroupLabel(group)}
            </MenuItem>
          ))
        )}
      </TextField>
    </Box>
  );
}

export default ChatWidgetGroupSelect;
